export const BRAND_KEY = "BRAND";

export const BRAND_CACHE_KEYS = {
  LIST: [BRAND_KEY, "LIST"] as const,
  DETAIL: (id: string) => [BRAND_KEY, id] as const,
};
